import { apiFetch } from "./api";
import type { PagedResult } from "./clients-accounts";

// DTO mirrors the generic lookup registration for printers (LookupEndpointsFactory).
// Field names match web/src/pages/admin/lookups/PrintersPage.tsx's `Row`.
export interface PrinterDto {
  printerId: number;
  printerName: string;
  description: string | null;
  standardA4Printer: boolean;
  labelPrinter: boolean;
  deleted: boolean;
}

export const printersApi = {
  /**
   * All active printers. The registry is a small lookup table, so one 200-row page is the whole
   * list — callers filter by `labelPrinter` / `standardA4Printer` client-side.
   */
  list: async (): Promise<PrinterDto[]> => {
    const res = await apiFetch<PagedResult<PrinterDto>>(
      "/api/lookups/printers?page=0&pageSize=200&deleted=false",
    );
    if (res.totalCount > res.items.length) {
      console.warn(
        `printersApi.list: /api/lookups/printers reported totalCount=${res.totalCount} but only ${res.items.length} items were returned in one page — some printers are missing from callers.`,
      );
    }
    return res.items;
  },
};
